module.exports = __webpack_public_path__ + "static/img/s102.90cded6f.png";